const jsBridge = {
  install (Vue) {
    Object.defineProperty(Vue.prototype, '$app', {
      value: this,
      writable: false,
    });

    try {
      this.connectWebViewJavascriptBridge(bridge => {
        bridge.init((message, responseCallback) => {
          console.log(message, responseCallback);
        });
      });
    } catch (e) {
      console.log(`WebViewInitError: ${  JSON.stringify(e)}`);
    }
  },
  // 是否安卓系统
  isAndroid:
    /Android/.test(window.navigator.userAgent) ||
    /Linux/.test(window.navigator.userAgent),
  // 是否苹果手机
  isIphone: /Iphone/.test(window.navigator.userAgent),
  // 是否在微信平台
  isWeixin: /MicroMessenger/i.test(window.navigator.userAgent),
  /**
   * 调用客户端方法封装函数
   * @param callback function 回调函数
   */
  connectWebViewJavascriptBridge (callback) {
    if (window.WebViewJavascriptBridge) {
      callback(window.WebViewJavascriptBridge);
    } else {
      document.addEventListener(
        'WebViewJavascriptBridgeReady',
        function () {
          callback(window.WebViewJavascriptBridge);
        },
        false
      );
    }
  },
  /*
   *  客户端调用评论与正文切换方法举例，以jsbrige 方法与客户端桥接，而不是window
   * */
  notifyWebHandleEvent(callback) {
    try {
      this.connectWebViewJavascriptBridge(bridge => {
        bridge.registerHandler(
          'notifyWebHandleEvent',
          function (data, responseCallback) {
            const responseData = 'Javascript Says Right back aka!';
            callback(data);
            responseCallback(responseData);
          }
        );
      });
    } catch (e) {
      // console.log('WebViewInitError: ' + JSON.stringify(e))
    }
  },

  /* 通知取消刷新 */
  hasReffishOk() {
    try {
      this.connectWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler(
          'notifyWebHandleEvent',
          {
            method: 'HXWebFinishCustomRefresh',
          },
          function (response) {
            console.log(response);
          }
        );
      });
    } catch (e) {
      console.log(`gobackError: ${  JSON.stringify(e)}`);
    }
  },

  /* 通知客户端刷新高度 */
  refreshHeight(param) {
    let conHeight = param.height;
    if (!this.isAndroid) {
      conHeight = param.height;
      //    window.HTMLOUT.getContentHeight(param.height)
    } else {
      conHeight = (param.height * devicePixelRatio).toFixed(0);
    }
    try {
      this.connectWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler(
          'notifyWebHandleEvent',
          {
            method: 'FetchWebHeight',
            params: {
              height: `${conHeight  }`,
            },
          },
          function (response) {
            console.log(response);
          }
        );
      });
    } catch (e) {
      console.log(`gobackError: ${  JSON.stringify(e)}`);
    }
  },

  /**
   * 调用客户端方法获取手机号信息给后台
   * @param params object 传进来之后客户端还会返回的参数，用在客户端回调中
   */
  getClientInfo (params = {}) {
    return new Promise((resolve, reject) => {
      const data = {
        info_type: 'wt',
        call_type: 'fetch',
        key_type: 'bh_sc',
      };
      const bridgeParams = Object.assign({}, data, params);
      try {
        this.connectWebViewJavascriptBridge(function (bridge) {
          bridge.callHandler('getUserInfoByRsa', bridgeParams, function (response) {
            if (response) {
              console.log('getClientInfo 客户端登录', response);
              localStorage.setItem('login_message', response.param);
              resolve(response);
            } else {
              console.log('getClientInfo 客户端登录失败', response);
              reject(new Error('用户信息查询失败!'));
            }
          });
        });
      } catch (e) {
        console.log('cash', e);
        reject(e);
      }
    });
  },
  /**
   * 调用客户端分享 params =
   *{title:'测试分享',
   *intrduct:'分分享数据内容，测试用的。',
   *url:'https://www.baidu.com/'
   * }
   */
  share(params = {}) {
    try {
      this.connectWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler('hexinShare', params, function (response) {
          console.log(response);
        });
      });
    } catch (e) {
      console.log(`ShareError: ${  JSON.stringify(e)}`);
    }
  },
  //分享至微信端
  // appWxShare 参数：title(标题) introduct(内容） url（分享url) shareScene(session朋友，timeline朋友圈，不传则弹框让用户选择）
  appWxShare(params) {
    try {
      this.connectWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler('appWxShare', params, function (response) {
          console.log(response);
        });
      });
    } catch (e) {
      console.log(`ShareError: ${  JSON.stringify(e)}`);
    }
  },
  /**
   * 客户端回退方法
   * @param {*Object} params 回退方法参数
   * type=component  如果再返回就返回原生传这个，type=webpage再返回返回网页传这个
   */
  iosGoBack(params = {}) {
    try {
      this.connectWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler('goback', params, function (response) {
          console.log(response);
        });
      });
    } catch (e) {
      console.log(`gobackError: ${  JSON.stringify(e)}`);
    }
  },
  /**
   * 客户端打开文件方法
   * @param {*Object} params 参数
   * @param {string} params.url 打开文件路径
   * @param {string} params.filetype 打开的文件类型，有PDF,XLSX两种类型，安卓额外支持DOC和DOCX
   * @param {string} params.title 打开的文件名称
   */
  downloadFile(params) {
    if (!params.url.includes('http:') && !params.url.includes('https:')) {
      params.url =
        `${window.location.protocol}//${location.hostname}:${location.port}/${params.url}`;
    }
    try {
      this.connectWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler('HXDownloadFile', params, function (response) {
          console.log(response);
        });
      });
    } catch (e) {
      console.log(`HXDownloadFile: ${  JSON.stringify(e)}`);
    }
  },
  HXDownloadFile(params) {
    return this.downloadFile(params);
  },
  // 判断是不是在客户端内
  isMyIHexinapp() {
    const data = navigator.userAgent;
    return data.includes('Hexin');
  },

  registerNativeTTSNotify(callback) {
    try {
      this.connectWebViewJavascriptBridge(bridge => {
        bridge.registerHandler('NotifyNativeEventToWeb', function (data) {
          callback(data);
        });
      });
    } catch (e) {
      console.log('registerNativeTTSNotify ~ e', e);
    }
  },

  clientPhysicalReturn(data, responseCallback) {
    responseCallback(false);
  },
  /*
   *通过navigator.userAgent从客户端拿取版本号
   * */
  isVersion() {
    // 示例 UA:
    // Mozilla/5.0 ... Hexin_Gphone/9.00.38 ... innerversion/G037.08.123.1.32
    const data = navigator.userAgent;
    const obj = data.split(' ');
    const targetVersionName = this.isAndroid ? 'Hexin_Gphone' : 'build';
    for (let i = 0; i < obj.length; i++) {
      const [versionName, versionNumber = ''] = obj[i].split('/');
      if (versionName === targetVersionName) {
        return versionNumber;
      }
    }
    return '';
  },
  /**
   * 获取APP和硬件相关信息
   * size:7
   * appname:'广州证券'
   * osversion: 5.1 //系统版本号
   * device:'1501_M02'
   * net:'wifi'
   * appver:'V7.9'
   * internalVersion:'G037.08.55
   * sourceid:552
   */
  getAppInfo(params = {}) {
    return new Promise((resolve, reject) => {
      try {
        this.connectWebViewJavascriptBridge(function (bridge) {
          bridge.callHandler('getAppInfo', params, function (response) {
            if (response) {
              resolve(response);
            } else {
              reject(new Error('获取硬件信息失败!'));
            }
          });
        });
      } catch (e) {
        console.log(`getAppInfoError: ${  JSON.stringify(e)}`);
      }
    });
  },
  /*
   * 判断是否是传入支持当前版本
   * @param [array] BaseAnd 要支持的版本
   * */
  baseVersion(BaseAnd) {
    const version = this.isVersion();
    if (!version) {
      return false;
    }
    const currentVersion = version.split('.');
    for (let i = 0; i < BaseAnd.length; i++) {
      const vs = currentVersion[i] || '';
      if (BaseAnd[i] < vs) {
        return true;
      }
      if (BaseAnd[i] > vs) {
        return false;
      }
    }
    return true;
  },
  BaseVersion(BaseAnd) {
    return this.baseVersion(BaseAnd);
  },
  /*
   * 版本号判断及页面回调
   * @param fun [function] 回调函数
   * @param version [array] 要兼容的版本号
   * */
  isLoginAndroidIOS(fun, version) {
    let fal = false;
    const BaseAnd = version || ['9', '00', '38'];
    const BaseIOS = version || ['2', '4', '4'];
    if (this.isAndroid) {
      fal = this.baseVersion(BaseAnd);
    } else {
      fal = this.baseVersion(BaseIOS);
    }
    if (typeof fun === 'function') {
      fun(fal);
    }
  },
  /*
   *  客户端andorid物理返回调用
   * */
  clientPhysicalReturnFun() {
    try {
      this.connectWebViewJavascriptBridge(bridge => {
        bridge.registerHandler(
          'clientPhysicalReturn',
          function (data, responseCallback) {
            console.log(data, responseCallback, 'clientPhysicalReturn');
            // var responseData = 'Javascript Says Right back aka!'
            window.IosAndorid.clientPhysicalReturn(data, responseCallback);
            // responseCallback(responseData)
          }
        );
      });
    } catch (e) {
      console.log(`WebViewInitError: ${  JSON.stringify(e)}`);
    }
  },
  /*
   *  客户端调用消息中心，以jsbrige 方法与客户端桥接，而不是window
   * */
  clientMessageReminderFun() {
    try {
      this.connectWebViewJavascriptBridge(bridge => {
        bridge.registerHandler(
          'clientMessageReminder',
          function (data, responseCallback) {
            const responseData = 'Javascript Says Right back aka!';
            window.IosAndorid.clientMessageReminder(data);
            responseCallback(responseData);
          }
        );
      });
    } catch (e) {
      console.log(`WebViewInitError: ${  JSON.stringify(e)}`);
    }
  },
  clientMessageReminder(data) {
    console.log(data);
  },
  callBridgeHandler(handlerName, params, errorMessage) {
    return new Promise((resolve, reject) => {
      try {
        this.connectWebViewJavascriptBridge(function (bridge) {
          bridge.callHandler(handlerName, params, function (response) {
            if (response) {
              resolve(response);
            } else {
              reject(new Error(errorMessage));
            }
          });
        });
      } catch (e) {
        console.log('cash', e);
        reject(e);
      }
    });
  },
  /* 图片放大功能
   * handlerName: displayImageThumbnail
   * data: { currentIndex, originImages, detailImages }
   * */
  displayImageThumbnail(params) {
    const bridgeParams = {
      currentIndex: 0,
      ...params,
    };
    console.log('displayImageThumbnail', bridgeParams);
    return this.callBridgeHandler(
      'displayImageThumbnail',
      bridgeParams,
      '图片保存失败!'
    );
  },
  setTabBarHidden(params) {
    const bridgeParams = {
      // hidden: params.hidden
      ...params,
    };
    console.log('setTabBarHidden', bridgeParams);
    return this.callBridgeHandler(
      'setTabBarHidden',
      bridgeParams,
      '设置 TabBar 失败!'
    );
  },
  /**
   * 客户端切换tab栏时会触发的全局函数
   */
  ClientCallbackEvents() {
    console.log('切换成功');
  },
  // 安卓默认走这个方法
  showDownload() {
    console.log('showDownload');
  },
  /*
   * 登出方法
   * */
  loginAjaxOut() {
    try {
      this.connectWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler('wtLogOut', {}, function (response) {
          console.log(response);
        });
      });
    } catch (e) {
      // console.log('ShareError: ' + JSON.stringify(e))
    }
  },
  /**
   * 让首页能跟顶部栏没有距离
   */
  setTopToZero(params = {}) {
    return new Promise((resolve, reject) => {
      try {
        this.connectWebViewJavascriptBridge(function (bridge) {
          bridge.callHandler('setStatusBarState', params, function (response) {
            if (response) {
              resolve(response);
            } else {
              reject(new Error('获取当前webview失败!'));
            }
          });
        });
      } catch (e) {
        console.log(`setStatusBarState: ${  JSON.stringify(e)}`);
      }
    });
  },
  /**
   * @param  { String } action getAllStocks,addStocks,delStocks,updateStocks,queryStocks
   */
  selfCodeAction(action) {
    return new Promise(resolve => {
      this.connectWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler('selfCodeAction', { action }, response => {
          resolve(response);
        });
      });
    });
  },
  zxVoiceBroadcast(params) {
    return new Promise(resolve => {
      this.connectWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler('zxVoiceBroadcast', params, response => {
          resolve(response);
        });
      });
    });
  },
};

window.IosAndorid = jsBridge;
window.connectWebViewJavascriptBridge = jsBridge.connectWebViewJavascriptBridge;

export default jsBridge;
